import { createLocationAction } from 'actionCreators/createLocationAction'
import { createErrorAction } from 'kat/lib/actionCreators/createErrorAction'
import { appRoutes } from './../../../functions/routes/appRoutes'
import { HistoryAction } from 'kat/lib/actionCreators/types/HistoryAction'
import { SubmitUpdateLabelAction } from './../../../actionCreators/submit/SubmitUpdateLabelAction'
import { PatchWorkspacesRequestActionDefault } from './../../../actionCreators/types/PatchWorkspacesRequestActionDefault'
import { put, select } from 'redux-saga/effects'
import { StateReducers } from 'state/reducers/types/StateReducers'
import { selectState } from 'kat/lib/state/selectState'
import { takeGaurd } from 'kat/lib/utilities/takeGaurd'

const description = 'submitUpdateLabelFlow'

export const submitUpdateLabelFlow = function* () {
  while (1) {
    const action: SubmitUpdateLabelAction =
      yield takeGaurd<SubmitUpdateLabelAction>('SUBMIT_UPDATE_LABEL_ACTION')
    const { labelId, values } = action
    const state: StateReducers = yield select(selectState)
    const workspace = state.currentWorkspace
    const workspaceId = state.currentWorkspaceId || ''
    const labels = workspace?.labels
    const isRoutes = state.currentLocation?.isRoutes
    const editLabelRoute = isRoutes?.editLabelRoute

    if (workspaceId && labelId && labels) {
      const newLabels = labels.map((label) => {
        if (label.id === labelId) {
          return {
            ...label,
            ...values,
          }
        }

        return label
      })

      yield put<PatchWorkspacesRequestActionDefault>({
        type: 'PATCH_WORKSPACES_REQUEST',
        description,
        requestValues: {
          items: {
            [workspaceId]: {
              data: {
                labels: newLabels,
              },
            },
          },
        },
      })

      if (editLabelRoute) {
        yield put<HistoryAction>(
          createLocationAction({
            description,
            method: 'push',
            query: state.currentLocation?.query,
            pathname: appRoutes.labelsRoute.pathname,
          })
        )
      }
    } else {
      yield put(createErrorAction({ description }))
    }
  }
}
